/*
 * Home moderna — Mucho Divertido (assets/home-modern.js)
 * ------------------------------------------------------
 * Compañero de assets/home-modern.css. Solo se carga en la portada.
 *
 * Qué hace:
 * 1. Marca los bloques de cada sección de la home con .mdv-reveal y los muestra (.is-in)
 *    cuando entran en pantalla, escalonando las tarjetas de una misma sección (--mdv-i).
 *    Usa IntersectionObserver y, como red de seguridad, una comprobación por posición
 *    al hacer scroll. En Dwell el scroll de escritorio lo hace .page-wrapper, no la ventana,
 *    así que el listener va en captura sobre el documento.
 * 2. Marca con .mdv-card los grupos con fondo de color (newsletter, envío) para darles
 *    elevación y sombra al pasar el ratón.
 * 3. Al pulsar la tarjeta de newsletter (enlace a #contact_form) enfoca el campo de email
 *    del formulario del pie.
 *
 * Sin JavaScript, o con "reducir movimiento", o dentro del editor de temas, no se oculta nada.
 *
 * Rendimiento (17/10/2026): en cada bucle se hacen primero todas las lecturas de layout
 * (getBoundingClientRect, getComputedStyle) y después todas las escrituras (clases, estilos).
 * Alternarlas obligaba al navegador a recalcular el layout en cada vuelta (Lighthouse
 * marcaba una tarea de 250 ms de este script en móvil).
 */
(function () {
  var d = document;
  var html = d.documentElement;
  var main = d.querySelector('main[data-template="index"]');
  if (!main) return;

  /* ---- 3. Newsletter: enfocar el email del pie al llegar (se hace siempre, con o sin animaciones) */
  var nlLinks = main.querySelectorAll('a.group-block__link[href="#contact_form"]');
  for (var n = 0; n < nlLinks.length; n++) {
    nlLinks[n].addEventListener('click', function () {
      setTimeout(function () {
        var input = d.querySelector('#contact_form input[type="email"]');
        if (input) input.focus({ preventScroll: true });
      }, 650);
    });
  }

  /* ---- 2. Tarjetas con fondo */
  var groups = main.querySelectorAll('.group-block');
  var conFondo = [];
  for (var g = 0; g < groups.length; g++) { /* lecturas */
    var bg = getComputedStyle(groups[g]).backgroundColor;
    if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') conFondo.push(groups[g]);
  }
  for (g = 0; g < conFondo.length; g++) conFondo[g].classList.add('mdv-card'); /* escrituras */

  /* ---- 1. Entradas al hacer scroll */
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('classList' in html)) return;

  /* .garantias__item: cada fila de la banda de garantías entra escalonada (sections/banda-garantias.liquid) */
  var SEL = '.product-card, .collection-card, .valores__item, .garantias__item, .group-block, .text-block, .button:not(.button-unstyled):not(.slideshow-control), .button-secondary, .image-block, .jdgm-widget';
  var sections = main.querySelectorAll(':scope > .shopify-section');
  var targets = [];

  var alturas = [];
  for (var s = 0; s < sections.length; s++) alturas.push(sections[s].getBoundingClientRect().height); /* lecturas */

  for (s = 0; s < sections.length; s++) {
    var sec = sections[s];
    if (sec.querySelector('.hero')) continue; /* el hero ya tiene su propia entrada (bloque Hero moderno de mucho-divertido.css) */
    if (alturas[s] === 0) continue; /* secciones vacías o desactivadas */

    var found = sec.querySelectorAll(SEL);
    var items = [];
    for (var f = 0; f < found.length; f++) {
      var el = found[f];
      var parentMatch = el.parentElement && el.parentElement.closest(SEL);
      if (parentMatch && sec.contains(parentMatch)) continue; /* solo el nivel superior, sin anidar animaciones */
      items.push(el);
    }
    if (!items.length && sec.firstElementChild) items = [sec.firstElementChild];

    for (var i = 0; i < items.length; i++) {
      items[i].style.setProperty('--mdv-i', String(Math.min(i, 7))); /* escrituras */
      targets.push(items[i]);
    }
  }
  if (!targets.length) return;

  html.classList.add('mdv-js');

  function viewportHeight() {
    return window.innerHeight || html.clientHeight;
  }
  function inView(el, vh) {
    var r = el.getBoundingClientRect();
    return r.top < vh * 0.94 && r.bottom > 0;
  }
  function show(el) {
    /* El escalonado (--mdv-i) se aplica con un retardo en JS: como transition-delay en CSS
       también retrasaría la transición del hover una vez visible. */
    var i = parseInt(el.style.getPropertyValue('--mdv-i'), 10) || 0;
    if (!i) {
      el.classList.add('is-in');
      return;
    }
    setTimeout(function () {
      el.classList.add('is-in');
    }, i * 80);
  }

  /* Lo que ya está en pantalla al cargar: si vamos a tiempo (antes del primer pintado) entra
     animado; si el script llega tarde, se muestra directamente para no parpadear. */
  var early = !(window.performance && performance.now && performance.now() > 1500);
  var pending = [];
  var visibles = [];
  var vh = viewportHeight();
  for (var t = 0; t < targets.length; t++) { /* lecturas */
    (inView(targets[t], vh) ? visibles : pending).push(targets[t]);
  }
  for (t = 0; t < targets.length; t++) targets[t].classList.add('mdv-reveal'); /* escrituras */
  if (early && visibles.length) {
    void html.offsetWidth; /* un solo reflow: fija el estado inicial para que la transición se ejecute */
  }
  for (t = 0; t < visibles.length; t++) show(visibles[t]);
  if (!pending.length) return;

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting) {
            show(entries[e].target);
            io.unobserve(entries[e].target);
          }
        }
      },
      { threshold: 0, rootMargin: '0px 0px -6% 0px' } /* cualquier píxel visible cuenta: así un bloque medio visible tras un salto también aparece */
    );
    for (var p = 0; p < pending.length; p++) io.observe(pending[p]);
  }

  /* Red de seguridad por posición: navegadores sin IntersectionObserver y casos límite. */
  function check() {
    var rest = [];
    var mostrar = [];
    var saltados = [];
    var alto = viewportHeight();
    for (var c = 0; c < pending.length; c++) { /* lecturas */
      var el = pending[c];
      if (el.classList.contains('is-in')) continue;
      var r = el.getBoundingClientRect();
      if (r.top < alto * 0.94 && r.bottom > 0) mostrar.push(el);
      else if (r.bottom < 0) saltados.push(el); /* saltado con un scroll rápido: se muestra sin animar */
      else rest.push(el);
    }
    for (c = 0; c < mostrar.length; c++) show(mostrar[c]); /* escrituras */
    for (c = 0; c < saltados.length; c++) saltados[c].classList.add('is-in');
    pending = rest;
    if (!pending.length) d.removeEventListener('scroll', check, true);
  }
  d.addEventListener('scroll', check, { capture: true, passive: true });
  window.addEventListener('load', check);
  window.addEventListener('resize', check);
  setTimeout(check, 400);
})();
